
import { Component, Vue, Prop } from "vue-property-decorator";

export interface Positions {
    clientX: any;
    clientY: any;
    movementX: number;
    movementY: number;
}
@Component({})
export default class Draggable extends Vue {

	@Prop({ type: Boolean, required: false, default: true })
	private draggable: boolean = true;

    private containerPosition: Positions = {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
    };

    $refs!: {
        container: any;
    };

    private mounted(){
        this.containerPosition.clientX = 0;
        this.containerPosition.clientY = 0;
    }

    private startDrag(event: any) {
		if (this.draggable) {
			this.containerPosition.clientX = event.clientX;
        	this.containerPosition.clientY = event.clientY;

			//assign the on mouse events to the drag and stop drag
			document.onmousemove = this.dragging;
			document.onmouseup = this.endDrag;
    	}
	}

    private dragging(event: any) {
        event.preventDefault()
        this.containerPosition.movementX = this.containerPosition.clientX - event.clientX;
        this.containerPosition.movementY = this.containerPosition.clientY - event.clientY;
        this.containerPosition.clientX = event.clientX;
        this.containerPosition.clientY = event.clientY;

        // set the element's new position:
        this.$refs.container.style.top = (this.$refs.container.offsetTop - this.containerPosition.movementY) + 'px';
        this.$refs.container.style.left = (this.$refs.container.offsetLeft - this.containerPosition.movementX) + 'px';
    }

    private endDrag () {
		this.preventOffScreen();

        // clear functions
        document.onmouseup = null;
        document.onmousemove = null;
    }

	private preventOffScreen() {
		// Check if the container is off-screen
		var verticalPosition = parseInt(this.$refs.container.style.top);
		var horizontalPosition = parseInt(this.$refs.container.style.left);
		var containerWidth = this.$refs.container.clientWidth;
		var containerHeight = this.$refs.container.clientHeight;

		if (verticalPosition < 0) {
			this.$refs.container.style.top = 0;
		}

		if ((verticalPosition + containerHeight) > window.innerHeight) {
			this.$refs.container.style.top = (window.innerHeight - containerHeight) + 'px';
		}

		if (horizontalPosition < 0) {
			this.$refs.container.style.left = 0;
		}

		if ((horizontalPosition + containerWidth) > window.innerWidth) {
			this.$refs.container.style.left = (window.innerWidth - containerWidth) + 'px';
		}
	}
}
